import { FormControl } from '@angular/forms';
import { VisibleToEnum } from 'webcommon/shared';

export interface FilterCommonFormControls {
  makeMyDefault: FormControl<boolean>;
  visibleTo: FormControl<VisibleToEnum>;
}

export enum FilterSubmitType {
  Apply = 'apply',
  Save = 'save',
  SaveAs = 'save_as',
  Clear = 'clear'
}
